import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=2015231b&scoped=true"
import script from "./DetailSection.vue?vue&type=script&lang=js"
export * from "./DetailSection.vue?vue&type=script&lang=js"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=2015231b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015231b",
  null
  
)

export default component.exports